import React, { MutableRefObject, RefObject, useEffect, useRef } from "react";
import cn from "classnames";
import dynamic from "next/dynamic";
import { Scrollbars as CustomScrollbars } from "react-custom-scrollbars-2";

const Scrollbars = ({
    id,
    renderAs,
    className,
    disableScrollParent,
    showOnHover = false,
    ...props
}: any) => {
    const layoutRef: MutableRefObject<any> = useRef<RefObject<any>>(null);
    const scrollRef = useRef<any>();

    useEffect(() => {
        if (disableScrollParent) {
            layoutRef.current = document.getElementById(id);
            if (layoutRef.current) {
                layoutRef.current.addEventListener("wheel", handleWheel);
            }
        }

        return () => {
            if (layoutRef.current) {
                layoutRef.current.removeEventListener("wheel", handleWheel);
            }
        };
    }, [disableScrollParent]);

    const handleWheel = (e: WheelEvent) => {
        const delta = -e.deltaY || -e.detail || 0;
        const scrollTop = layoutRef.current.scrollTop;
        const scrollHeight = layoutRef.current.scrollHeight;
        const height = layoutRef.current.offsetHeight;
        const up = delta > 0;
        if (!up && height + scrollTop >= scrollHeight) {
            e.preventDefault();
            e.stopPropagation();
        } else if (up && scrollTop <= 0) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const renderView = ({ style, ...props }: { style: any }) => {
        const customStyle = {
            overflowX: "hidden",
            marginBottom: 0,
        };
        const RenderAs = renderAs || "div";

        const onMouseEnter = () => {
            if (showOnHover) {
                scrollRef.current?.handleTrackMouseEnter();
            }
        };

        const onMouseLeave = () => {
            if (showOnHover) {
                scrollRef.current?.handleTrackMouseLeave();
            }
        };

        return (
            <RenderAs
                {...props}
                style={{ ...style, ...customStyle }}
                className={className}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                id={id}
            />
        );
    };

    const thumbVertical = ({ ...props }) => {
        return (
            <div
                {...props}
                className={cn("rounded-sm", "bg-[#000]/10")}
            ></div>
        );
    };

    const trackVertical = ({ style, ...props }: { style: any }) => {
        const customStyle = {
            width: 4,
            right: 2,
            top: 2,
            bottom: 2,
            zIndex: 100,
        };
        return (
            <div
                {...props}
                style={{ ...style, ...customStyle }}
                className="track-vertical"
            ></div>
        );
    };

    const trackHorizontal = ({ ...props }) => {
        return <div {...props} className="track-horizontal"></div>;
    };

    return (
        <CustomScrollbars
            {...props}
            ref={(ref) => (scrollRef.current = ref)}
            renderThumbVertical={thumbVertical}
            renderTrackVertical={trackVertical}
            renderTrackHorizontal={trackHorizontal}
            renderView={renderView}
        />
    );
};

export default dynamic(() => Promise.resolve(Scrollbars), {
    ssr: false,
});
